import { http } from 'services';

// Personal - Get profile picture
export function getProfilePicture(cbSuccess, cbError) {
  http.get(
    'personal/profile-picture',
    {},
    (result) => {
      cbSuccess(result.data);
    },
    (error) => {
      const errorParsed = http.defaultError(error);
      cbError(errorParsed.text, errorParsed.status, errorParsed.data);
    },
  );
}

// Personal - Set profile picture
export function setProfilePicture(image, cbSuccess, cbError) {
  const { FormData } = window;
  const form = new FormData();
  form.append('profile_picture', image);
  http.post(
    'personal/profile-picture',
    form,
    (result) => {
      cbSuccess(result.data);
    },
    (error) => {
      const errorParsed = http.defaultError(error);
      cbError(errorParsed.text, errorParsed.status, errorParsed.data);
    },
  );
}

// Personal - Remove profile picture
export function removeProfilePicture(cbSuccess, cbError) {
  http.delete(
    'personal/profile-picture',
    {},
    (response) => {
      cbSuccess(response.data);
    },
    (error) => {
      const errorParsed = http.defaultError(error);
      cbError(errorParsed.text, errorParsed.status, errorParsed.data);
    },
  );
}



// WEBPACK FOOTER //
// ./src/api/api-personal/api-personal-profile-picture.js